import axios from 'axios';

import { MempoolFees } from '../../common';

export const getSatPerVbEstimateFee = async (mempoolApiEndpoint: string): Promise<MempoolFees> => {
  try {
    const response = await axios.get(`${mempoolApiEndpoint}/fee-estimates`);
    const fees = response.data;
    const currentMempoolBlockFees = {
      economyFee: Number(fees['3'] ?? 0.1),
      minimumFee: Number(fees['6'] ?? 1.0),
      fastestFee: Number(fees['1'] ?? 1.0),
    };

    return currentMempoolBlockFees;
  } catch (error) {
    if (error instanceof Error) {
      console.error('Error fetching Dogecoin fees:', error.message);
    }

    return {
      economyFee: 0.01,
      minimumFee: 1.0,
      fastestFee: 1.0,
    };
  }
};
